<ng-container *ngFor="let successButton of successButtons[status]">
  <rd-shared-button
    [ngClass]="successButtonClass(successButton.buttonClass)"
    [buttonClass]="successButtonClass(successButton.buttonClass)"
    [buttonText]="successButton.buttonText | translate"
    [buttonTheme]="successButton.buttonTheme"
    [redirectURL]="successButton.redirectURL">
  </rd-shared-button>
</ng-container>
